import styled from "styled-components"

export const Container = styled.div`
  width: 100%;
  max-width: ${({ $narrow }) => ($narrow ? "820px" : "1200px")};
  margin: 0 auto;
  padding: 0 20px;
  @media (min-width: 576px) {
    padding: 0 24px;
  }
  @media (min-width: 992px) {
    padding: 0 32px;
  }
`
